import { getMessaging, getToken, isSupported } from "@firebase/messaging";

import usePushNotification from "./usePushNotification";

const useSendRegisterPushNotif = () => {
  const { addPushNotificationForLogin, fetchCancelNotif } =
    usePushNotification();

  const requestNotificationAfterLogin = (accessToken) => {
    return new Promise<void>(async (resolve, reject) => {
      const messaging = (await isSupported()) ? getMessaging() : null;
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          getToken(messaging).then((fcmToken) => {
            if (fcmToken) {
              addPushNotificationForLogin(fcmToken, accessToken).finally(() => {
                resolve();
              });
            } else {
              reject();
              console.warn("No registration token available.");
            }
          });
        } else {
          reject();
          console.warn("Notification permission denied or blocked.");
        }
      });
    });
  };

  const requestNotification = () => {
    return new Promise<void>((resolve, reject) => {
      const messaging = getMessaging();
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          getToken(messaging).then((token) => {
            if (token) {
              addPushNotification(token).then(() => {
                resolve();
              });
            } else {
              console.warn("No registration token available.");
              reject();
            }
          });
        } else {
          console.warn("Notification permission denied or blocked.");
          reject();
        }
      });
    });
  };

  return {
    requestNotification,
    requestNotificationAfterLogin,
    fetchCancelNotif,
  };
};

export default useSendRegisterPushNotif;
